import BidprojectService from '../service';
import Service from '../service';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    Pagination
  },
  computed: {
    ...mapGetters([
      'isSignin'
    ])
  },
  data() {
    return {
      tabList: [ { value: '供应', type: 1}, { value: '需求 ', type: 2}], // tab集合
      tabActiveType: 1,
      total: 0,
      tableList: [],
      status: '',
      pageNum: 1,
      pageSize: 10,
      productName: '',
      searchForm: {
        type: ''
      },
      typeList: []
    };
  },
  created() {
    Service.getSubTypeList({ tId: '66aaf74f247b9fffdb5eba08'}).then(res => {
      this.typeList = res;
    });
    this.getList();
  },
  methods: {
    changeSkin,
    changeTabIndex(type) {
      this.tabActiveType = type;
      this.getList();
    },

    searchFormAction() {
      this.searchForm.productName = this.productName;
      this.getList({ pageNo: 1, pageSize: 10});
    },

    searchTypeAction(item) {
      this.searchForm.type = item.type;
      this.getList({ pageNo: 1, pageSize: 10});
    },
    toDetail(item) {
      this.$router.push('/supply-and-demand/detail?id=' + item._id);
    },
    toAdd() {
      if (!this.isSignin) {
        this.$router.push('/signin');
        return;
      }
      this.$router.push('/supply-and-demand/add?subType=' + this.tabActiveType);
    },
    // 获取竞价列表
    getList(page){
      if (page && page.pageNo && page.pageSize) {
        this.searchForm.skip = (page.pageNo - 1) * 10;
        this.searchForm.limit = page.pageSize;
      }
      Service.getDemandList({
        subType: this.tabActiveType,
        // status: 3,
        ...this.searchForm,
        tId: '66aaf74f247b9fffdb5eba08'
      }).then(res => {
        this.tableList = res.result;
        this.total = res.total;
      }, () => {
        this.$errorMessage('请求失败');
      });
    },
    clear () {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        projectName: ''
      };
      this.getList();
    },
    goToSignUpDetail (obj) {
      BidprojectService.getEjyToken(obj.bidId).then(res => {
        if (res && res.code === '0' && res.data) {
          window.open(res.data);
          console.log(res.data, 'res.data.token');
        }
      }).catch((res) => {
        if(res.data.code !== '999') {
          this.$confirm('您还没报名该项目，请先报名后再竞价', '提示', {
            confirmButtonText: '立即报名',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.submit();
            if(this.tabActiveType === 1) {
              this.$router.push('/transaction-pro/detail?id=' + obj.projectId);
            } else {
              this.$router.push('/collective-purchasing/detail?id=' + obj.projectId);
            }
          }).catch(() => {
          });
        }
      });
    }
    // handdle (row, event, column) {
    //   console.log(row, event, column);
    //   this.$router.push('/notice-modular/detail?id=' + row.bidId + '&time=' + row.transactionAnnouncementTime + '&type=' + this.tabActiveType);
    // }
  }
};
